import { createContext } from 'react';
export const ComposerContext = createContext({
    withProvider: false,
    isTouched: false,
    editor: null,
    state: null,
    toggleDialog: null,
    onFileUpload: null,
    onSlashMenuItemClick: null,
});
//# sourceMappingURL=ComposerContext.js.map